var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from 'utils/apis/api';
import { transformCreateBulletinBoardApiResponse, transformCreateBulletinResponse, transformReadBulletinResponse, } from './utils/transformResponse';
export const bulletinboardsApi = api
    .enhanceEndpoints({
    addTagTypes: ['Bulletins'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        createBulletinBoard: builder.mutation({
            query: ({ organizationId }) => ({
                version: 1,
                path: 'bulletinboards',
                method: 'POST',
                body: { organization_id: organizationId },
            }),
            transformResponse: transformCreateBulletinBoardApiResponse,
        }),
        deleteBulletinBoard: builder.mutation({
            query: ({ boardId }) => ({
                version: 1,
                path: `bulletinboards/${boardId}`,
                method: 'DELETE',
            }),
        }),
        readBulletins: builder.query({
            query: ({ boardId }) => ({
                version: 1,
                path: `bulletinboards/${boardId}/bulletins`,
            }),
            providesTags: (readBulletinsResponse) => [
                ...((readBulletinsResponse === null || readBulletinsResponse === void 0 ? void 0 : readBulletinsResponse.data.bulletins) || []).map(({ id }) => ({
                    type: 'Bulletins',
                    id,
                })),
                { type: 'Bulletins', id: 'LIST' },
            ],
        }),
        createBulletin: builder.mutation({
            query: ({ boardId, title, order }) => ({
                version: 1,
                path: `bulletinboards/${boardId}/bulletins`,
                method: 'POST',
                body: { title, order },
            }),
            transformResponse: transformCreateBulletinResponse,
            invalidatesTags: [{ type: 'Bulletins', id: 'LIST' }],
        }),
        readBulletin: builder.query({
            query: ({ boardId, bulletinId }) => ({
                version: 1,
                path: `bulletinboards/${boardId}/bulletins/${bulletinId}`,
            }),
            transformResponse: transformReadBulletinResponse,
            providesTags: (readBulletinsResponse) => [
                Object.assign({ type: 'Bulletins' }, (readBulletinsResponse && {
                    id: readBulletinsResponse.id,
                })),
            ],
        }),
        deleteBulletin: builder.mutation({
            query: ({ boardId, bulletinId }) => ({
                version: 1,
                path: `bulletinboards/${boardId}/bulletins/${bulletinId}`,
                method: 'DELETE',
            }),
            onQueryStarted({ boardId, bulletinId }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const patchReadBulletins = dispatch(bulletinboardsApi.util.updateQueryData('readBulletins', { boardId }, (draft) => {
                        const mutableDraft = draft;
                        mutableDraft.data.bulletins = draft.data.bulletins.filter((bulletin) => bulletin.id !== bulletinId);
                    }));
                    try {
                        yield queryFulfilled;
                    }
                    catch (_a) {
                        patchReadBulletins.undo();
                    }
                });
            },
        }),
        updateBulletin: builder.mutation({
            query: ({ boardId, bulletinId, update: bulletinUpdate }) => ({
                version: 1,
                path: `bulletinboards/${boardId}/bulletins/${bulletinId}`,
                method: 'PATCH',
                body: bulletinUpdate,
            }),
            onQueryStarted({ boardId, bulletinId, update: bulletinUpdate }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const patchReadBulletins = dispatch(bulletinboardsApi.util.updateQueryData('readBulletins', { boardId }, (draft) => {
                        const mutableDraft = draft;
                        mutableDraft.data.bulletins = mutableDraft.data.bulletins
                            .map((bulletin) => bulletin.id === bulletinId
                            ? Object.assign(Object.assign({}, bulletin), bulletinUpdate) : bulletin)
                            .sort((bulletin1, bulletin2) => bulletin1.order - bulletin2.order);
                    }));
                    const patchReadBulletin = dispatch(bulletinboardsApi.util.updateQueryData('readBulletin', { boardId, bulletinId }, (draft) => {
                        const mutableDraft = draft;
                        for (const [key, value] of Object.entries(bulletinUpdate)) {
                            mutableDraft[key] = value;
                        }
                    }));
                    try {
                        yield queryFulfilled;
                    }
                    catch (_a) {
                        patchReadBulletins.undo();
                        patchReadBulletin.undo();
                    }
                });
            },
        }),
    }),
});
